import { useEffect, useState, CSSProperties } from 'react';

// Compensates for the sticky header + pinned tab bar so a native #hash jump to a
// section (anchor mode) doesn't land its top edge underneath them. Not used by
// tabs-mode tab clicks, which scroll via useTabQueryState's window.scrollTo instead.
// Mirrors the offset TitleText's own heading previously carried for the same reason.
const computeScrollMarginTop = (): Pick<CSSProperties, 'scrollMarginTop'> => {
  let newTop = 10;
  const header = document.querySelector('header');
  const tabNavigation = document.querySelector('#tabNavigation');
  if (header) {
    newTop += header.getBoundingClientRect().height;
  }
  if (tabNavigation) {
    newTop += tabNavigation.getBoundingClientRect().height;
  }
  return { scrollMarginTop: `${newTop}px` };
};

interface UseSectionScrollMarginTopParams {
  enabled: boolean;
}

export function useSectionScrollMarginTop({ enabled }: UseSectionScrollMarginTopParams) {
  const [scrollMarginTop, setScrollMarginTop] = useState<Pick<CSSProperties, 'scrollMarginTop'>>({});

  useEffect(() => {
    if (!enabled) {
      setScrollMarginTop({});
      return undefined;
    }
    setScrollMarginTop(computeScrollMarginTop());
    const onResize = () => setScrollMarginTop(computeScrollMarginTop());
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [enabled]);

  return scrollMarginTop;
}
